import { render, staticRenderFns } from "./AddPersonnelStatus.vue?vue&type=template&id=03937e35&scoped=true"
import script from "./AddPersonnelStatus.vue?vue&type=script&lang=js"
export * from "./AddPersonnelStatus.vue?vue&type=script&lang=js"
import style0 from "./AddPersonnelStatus.vue?vue&type=style&index=0&id=03937e35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03937e35",
  null
  
)

export default component.exports